import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//国际化
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh", // 定义默认语言为中文
  messages: {
    zh: require("@/assets/languages/zh.json"),
    en: require("@/assets/languages/en.json"),
  },
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  i18n,
  router,
  store,
  
  render: (h) => h(App),
}).$mount("#app");
